import { jsx as _jsx } from "react/jsx-runtime";
import UICheckoutButton from 'ui-addon-upgrades/button/UICheckoutButton';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import UITrialActivationButton from '../../../button/UITrialActivationButton';
import UIProductActivationButton from '../../../button/UIProductActivationButton';
import { CheckoutButtonPropsInterface } from 'ui-addon-upgrades/_core/checkout/CheckoutPropsInterface';
import { ContactSalesButtonPropsInterface } from 'ui-addon-upgrades/_core/contactSales/ContactSalesPropsInterface';
import ContactsConfirmationRedirectButton from 'ui-addon-upgrades/_core/additionalContacts/ContactsConfirmationRedirectButton';
import { BuyAdditionalContactsPropsInterface } from 'ui-addon-upgrades/_core/additionalContacts/BuyAdditionalContactsPropsInterface';
import { TrialActivationButtonPropsInterface } from '../../trial/TrialPropsInterface';
import { ProductActivationPropsInterface } from 'ui-addon-upgrades/_core/productActivation/ProductActivationPropsInterface';
import * as PurchaseMotions from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import UIAccountSummaryButton from '../../../button/UIAccountSummaryButton';
import { ViewAccountPropsInterface } from 'ui-addon-upgrades/_core/viewAccount/ViewAccountPropsInterface';
import UIPricingPageRedirectButton from '../../../button/UIPricingPageRedirectButton';
import { PricingPageRedirectButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/pricingPageRedirectButtonInterface';
import UIRequestSeatButton from 'ui-addon-upgrades/button/UIRequestSeatButton';
import UIAssignSeatButton from 'ui-addon-upgrades/button/UIAssignSeatButton';
import { RequestSeatButtonPropsInterface, AssignSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface';
import AddAdditionalSeatsButton from '../../additionalSeats/AddAdditionalSeatsButton';
import PricingPageInterstitialBuyNowButton from '../../interstitial/PricingPageInterstitialBuyNowButton';
import { PricingPageInterstitialButtonInterface } from '../../interstitial/PricingPageInterstitialButtonInterface';
import PricingPageInterstitialBuyContactsButton from '../../interstitial/PricingPageInterstitialBuyContactsButton';
import PricingPageInterstitialBuySeatsButton from '../../interstitial/PricingPageInterstitialBuySeatsButton';
export const purchaseMotionKeys = Object.keys(PurchaseMotions).map(k => PurchaseMotions[k]);
export const purchaseMotionButtons = {
  [PurchaseMotions.BUY_TOUCHLESS]: UICheckoutButton,
  [PurchaseMotions.TALK_TO_SALES]: props => /*#__PURE__*/_jsx(UIContactSalesButton, Object.assign({}, props, {
    isAssignable: true
  })),
  [PurchaseMotions.TALK_TO_SALES_FALLBACK]: props => /*#__PURE__*/_jsx(UIContactSalesButton, Object.assign({}, props, {
    isAssignable: false
  })),
  [PurchaseMotions.TRIAL]: UITrialActivationButton,
  [PurchaseMotions.BUY_ADDITIONAL_SEATS]: AddAdditionalSeatsButton,
  [PurchaseMotions.BUY_ADDITIONAL_CONTACTS]: ContactsConfirmationRedirectButton,
  [PurchaseMotions.ACTIVATE]: UIProductActivationButton,
  [PurchaseMotions.VIEW_ACCOUNT]: UIAccountSummaryButton,
  [PurchaseMotions.PRICING_PAGE_REDIRECT]: UIPricingPageRedirectButton,
  [PurchaseMotions.REQUEST_SEAT]: UIRequestSeatButton,
  [PurchaseMotions.ASSIGN_SEAT]: UIAssignSeatButton,
  [PurchaseMotions.CALCULATE_PRICE]: PricingPageInterstitialBuyNowButton,
  [PurchaseMotions.CALCULATE_CONTACTS]: PricingPageInterstitialBuyContactsButton,
  [PurchaseMotions.CALCULATE_SEATS]: PricingPageInterstitialBuySeatsButton
};
export const purchaseMotionButtonPropsInterface = {
  [PurchaseMotions.BUY_TOUCHLESS]: CheckoutButtonPropsInterface,
  [PurchaseMotions.TALK_TO_SALES]: ContactSalesButtonPropsInterface,
  [PurchaseMotions.TALK_TO_SALES_FALLBACK]: ContactSalesButtonPropsInterface,
  [PurchaseMotions.TRIAL]: TrialActivationButtonPropsInterface,
  [PurchaseMotions.BUY_ADDITIONAL_SEATS]: CheckoutButtonPropsInterface,
  [PurchaseMotions.BUY_ADDITIONAL_CONTACTS]: BuyAdditionalContactsPropsInterface,
  [PurchaseMotions.ACTIVATE]: ProductActivationPropsInterface,
  [PurchaseMotions.VIEW_ACCOUNT]: ViewAccountPropsInterface,
  [PurchaseMotions.PRICING_PAGE_REDIRECT]: PricingPageRedirectButtonPropsInterface,
  [PurchaseMotions.REQUEST_SEAT]: RequestSeatButtonPropsInterface,
  [PurchaseMotions.ASSIGN_SEAT]: AssignSeatButtonPropsInterface,
  [PurchaseMotions.CALCULATE_PRICE]: PricingPageInterstitialButtonInterface,
  [PurchaseMotions.CALCULATE_CONTACTS]: PricingPageInterstitialButtonInterface,
  [PurchaseMotions.CALCULATE_SEATS]: PricingPageInterstitialButtonInterface
};
export const purchaseMotionData = ['currencyCode', 'productConfigurations', 'offerProductConfigurations', 'nonRecurringProductConfigurations', 'purchaseMotions', 'trialId'];